import React from "react";
import { Div, Text3 } from "components/Base";
import { Link } from "react-router";

const ICON_STYLES = {
  width: "16px",
  height: "16px",
  fontSize: "16px"
};

const QuickLinkThumbnail = ({
  url = "",
  text = "",
  icon = "material-icons,bookmark",
  color = "#4263EB"
}) => {
  const [iconClass, iconName] = icon.split(",");
  return (
    <Div
      width={1}
      py={2}
      px={3}
      display="row.space-between.center"
      bc="#E7E6EA"
      bg="#FAFAFA"
      b={1}
      style={{ borderRadius: "6px" }}
    >
      <Div display="row.flex-start.center">
        <i style={{ ...ICON_STYLES, color }} className={iconClass}>
          {iconName}
        </i>
        <Text3 bold color="#494949" ml={1}>
          {text}
        </Text3>
      </Div>
      <Link onlyActiveOnIndex target="_blank" to={url}>
        <i
          style={{ color: "#4263EB", fontSize: "16px" }}
          className="material-symbols-outlined"
        >
          open_in_new
        </i>
      </Link>
    </Div>
  );
};

export default QuickLinkThumbnail;
